const handleTemp = (state = {}, action) => {
    switch (action.type) {
      case 'SET_TEMP':
        return state  = action.data;
      default:
        return state;
    }
  };
  
  export default handleTemp;